import { pluralRu } from './pluralRu'

type AttentionChipProps = {
  count: number
  active: boolean
  onToggle: () => void
}

/**
 * Единственный сигнал о сопоставлении, который видит пользователь «Моих прайсов»: сколько
 * позиций стоит проверить. Нажатие показывает только их, повторное — всё. Статусы «авто /
 * предложено / вручную» — внутренняя кухня матчера и наружу не выходят.
 */
export const AttentionChip = ({ count, active, onToggle }: AttentionChipProps) => {
  if (count <= 0) {
    return (
      <span className="market-attention-chip market-attention-chip--done">
        <CheckIcon />
        Все категории проверены
      </span>
    )
  }
  const label = `${count} ${pluralRu(count, 'позиция требует', 'позиции требуют', 'позиций требуют')} внимания`
  return (
    <button
      type="button"
      className={`market-attention-chip${active ? ' market-attention-chip--active' : ''}`}
      aria-pressed={active}
      title={active ? 'Показать все позиции' : 'Показать только их'}
      onClick={onToggle}
    >
      <AlertIcon />
      <span>{label}</span>
      {active ? <CloseIcon /> : null}
    </button>
  )
}

const AlertIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v4" />
    <path d="M12 16h.01" />
  </svg>
)

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 6 9 17l-5-5" />
  </svg>
)

const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
)
